(function($) {
    'use strict';

    const Fanzone = {
        apiBase: '/wp-json/common/v1/fanzone',

        init: function() {
            this.initLoadMore();
        },

        buildPostCard: function(post) {
            var linkUrl = (post.link && post.link.url) ? post.link.url : '#';
            var linkTarget = (post.link && post.link.target) ? post.link.target : '';
            var linkTitle = (post.link && post.link.title) ? post.link.title : (post.title || '');
            var targetAttr = linkTarget ? ' target="' + linkTarget + '"' : '';
            var titleAttr = linkTitle ? ' title="' + this.esc(linkTitle) + '"' : '';
            var imgAlt = this.esc(linkTitle || 'Community post');

            var html = '<div class="break-inside-avoid">' +
                '<a href="' + this.esc(linkUrl) + '"' + targetAttr + ' rel="noopener nofollow noreferrer"' + titleAttr +
                ' class="block bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all cursor-pointer">' +
                '<div class="relative w-full">' +
                '<img class="w-full h-auto object-cover" src="' + this.esc(post.image_url) + '" alt="' + imgAlt + '" loading="lazy">' +
                '</div>';

            if (post.has_description && post.description) {
                html += '<div class="p-4">' +
                    '<p class="text-gray-800 text-sm mb-3 leading-relaxed">' + post.description.replace(/\n/g, '<br>') + '</p>' +
                    '<div class="flex flex-col gap-2 items-center justify-between pt-3 border-t border-gray-200">' +
                    '<div class="flex items-center gap-2 w-full"><div class="flex -space-x-1"><span class="text-lg">👍</span><span class="text-lg">❤️</span></div><span class="text-xs text-gray-600">Nhiều người</span></div>' +
                    '<div class="flex items-center gap-4 w-full">' +
                    '<button type="button" class="flex items-center gap-1 text-gray-600 hover:text-blue-600 text-sm" onclick="event.preventDefault();event.stopPropagation();"><svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"></path></svg><span class="hidden md:block">Thích</span></button>' +
                    '<button type="button" class="flex items-center gap-1 text-gray-600 hover:text-blue-600 text-sm" onclick="event.preventDefault();event.stopPropagation();"><svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"></path></svg><span class="hidden md:block">Bình luận</span></button>' +
                    '<button type="button" class="flex items-center gap-1 text-gray-600 hover:text-blue-600 text-sm" onclick="event.preventDefault();event.stopPropagation();"><svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z"></path></svg><span class="hidden md:block">Chia sẻ</span></button>' +
                    '</div></div></div>';
            }

            html += '</a></div>';
            return html;
        },

        esc: function(str) {
            if (str === null || str === undefined) return '';
            return String(str)
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;');
        },

        initLoadMore: function() {
            var self = this;
            var $btn = $('#fanzone-load-more');
            if (!$btn.length) return;

            var vars = window.fanzoneVars || {};
            var loaded = parseInt(vars.loaded) || 0;
            var limit = parseInt(vars.limit) || 8;
            var apiUrl = vars.rest_url || (this.apiBase + '/posts');

            $btn.on('click', function() {
                $btn.text('Đang tải...').prop('disabled', true);

                var url = apiUrl + (apiUrl.indexOf('?') !== -1 ? '&' : '?') + 'offset=' + loaded + '&limit=' + limit;

                $.getJSON(url)
                    .done(function(data) {
                        if (data.success && data.posts && data.posts.length > 0) {
                            var $grid = $('.fanzone-posts-grid');
                            if ($grid.length) {
                                $.each(data.posts, function(_, post) {
                                    $grid.append(self.buildPostCard(post));
                                });
                            }
                            loaded += data.posts.length;
                            if (!data.has_more) {
                                $btn.parent().hide();
                            } else {
                                $btn.text('Xem thêm').prop('disabled', false);
                            }
                        } else {
                            $btn.parent().hide();
                        }
                    })
                    .fail(function() {
                        $btn.text('Xem thêm').prop('disabled', false);
                    });
            });
        }
    };

    // Initialize on DOM ready
    $(document).ready(function() {
        Fanzone.init();
    });

})(jQuery);
